<template>
  <div class="main_style">
    <NavBarHome v-if="navBarStyle === '1'" textColor="#000000" :iconUrl="require('@/assets/img/home/logo-2.png')"/>
    <NavBar v-else />
    <div class="header">
      <div class="header-text">
        <p class="header-title">ChainSQL功能调用平台</p>
        <p class="header-desc">
          ChainSQL功能调用平台可以界面化使用ChainSQL的全部功能。目前，ChainSQL产品所有的功能均通过代码形式进行展现，为方便用户更加直观的使用ChainSQL的功能，众享科技推出了ChainSQL功能调用平台。
        </p>
      </div>
    </div>
    <!-- 产品介绍 -->
    <div class="intro">
      <div class="commom-title">产品介绍</div>
      <div class="intro-content">
        <p>
          ChainSQL功能调用平台可以界面化使用ChainSQL的全部功能。目前，ChainSQL产品所有的功能均通过代码形式进行展现，为方便用户更加直观的使用ChainSQL的功能，众享科技推出了ChainSQL功能调用平台。开发者和体验者可以直接通过ChainSQL功能调用平台完成ChainSQL开发的调试与使用。ChainSQL功能调用平台支持用户进行ChainSQL上的数据库操作交易、特色功能、普通区块链交换和账户管理等功能。
        </p>
      </div>
    </div>
    <!-- 核心功能 -->
    <div class="function">
      <div class="commom-title">核心功能</div>
      <div class="content">
        <el-row :gutter="24" class="grid">
          <el-col :span="8"
            ><div class="grid-content">
              <div class="img">
                <img
                  src="@/assets/img/product/FunctionAdjustment/function-1.png"
                />
              </div>
              <div class="title">数据库功能</div>
              <div class="text">
                表管理、表操作、数据操作、授权、事务
              </div>
            </div></el-col
          >
          <el-col :span="8"
            ><div class="grid-content">
              <div class="img">
                <img
                  src="@/assets/img/product/FunctionAdjustment/function-2.png"
                />
              </div>
              <div class="title">特色功能</div>
              <div class="text">
                审计、Dump、智能合约
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="grid-content">
              <div class="img">
                <img
                  src="@/assets/img/product/FunctionAdjustment/function-3.png"
                />
              </div>
              <div class="title">地址管理</div>
              <div class="text">
                生成账户地址、账户地址列表
              </div>
            </div>
          </el-col>
					<el-col :span="8">
            <div class="grid-content">
              <div class="img">
                <img
                  src="@/assets/img/product/FunctionAdjustment/function-4.png"
                />
              </div>
              <div class="title">账户管理</div>
              <div class="text">
                账户总览、转账、信任、分发记录
              </div>
            </div>
          </el-col>
					<el-col :span="8">
            <div class="grid-content">
              <div class="img">
                <img
                  src="@/assets/img/product/FunctionAdjustment/function-5.png"
                />
              </div>
              <div class="title">JSON操作</div>
              <div class="text">
                表操作、数据操作、其他交易操作
              </div>
            </div>
          </el-col>
					<el-col :span="8">
            <div class="grid-content">
              <div class="img">
                <img
                  src="@/assets/img/product/FunctionAdjustment/function-6.png"
                />
              </div>
              <div class="title">订阅管理</div>
              <div class="text">
                表订阅、交易订阅
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <!-- 产品架构 -->
    <div class="framework">
      <div class="commom-title">产品架构</div>
      <div class="framework-content">
        <img src="https://image.peerfintech.cn/peerfintech_website_v2/product/FunctionAdjustment/framework.png" />
      </div>
    </div>
    <!-- 产品优势 -->
    <div class="advantage">
      <div class="commom-title">产品优势</div>
      <div class="advantage-content">
        <el-row :gutter="24">
          <el-col :span="12"
            ><div class="grid-content">
              <div class="img">
                <img
                  src="@/assets/img/product/FunctionAdjustment/advantage-1.png"
                />
              </div>
              <div class="title">代码界面化</div>
              <div class="text">
                通过可视化界面快速的使用ChainSQL的功能
              </div>
            </div></el-col
          >
          <el-col :span="12"
            ><div class="grid-content">
              <div class="img">
                <img
                  src="@/assets/img/product/FunctionAdjustment/advantage-2.png"
                />
              </div>
              <div class="title">功能丰富</div>
              <div class="text">
                包含ChainSQL区块链的所有功能
              </div>
            </div></el-col
          >
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12"
            ><div class="grid-content">
              <div class="img">
                <img
                  src="@/assets/img/product/FunctionAdjustment/advantage-3.png"
                />
              </div>
              <div class="title">结果定位清楚</div>
              <div class="text">
                每笔操作的结果显示都定位清楚，方便快速查找原因
              </div>
            </div></el-col
          >
          <el-col :span="12"
            ><div class="grid-content">
              <div class="img">
                <img
                  src="@/assets/img/product/FunctionAdjustment/advantage-4.png"
                />
              </div>
              <div class="title">操作方便</div>
              <div class="text">
                不懂代码的用户也可以使用区块链技术
              </div>
            </div></el-col
          >
        </el-row>
      </div>
    </div>
    <!-- 相关项目 -->
    <div class="project">
      <div class="commom-title">相关项目</div>
      <div class="project-content">
        <el-row :gutter="24">
          <el-col :span="8"
            ><div class="grid-content">
              <div class="img">
                <img
                  src="@/assets/img/product/FunctionAdjustment/project-1.png"
                />
              </div>
              <div class="title">ChainSQL</div>
            </div></el-col
          >
        </el-row>
      </div>
    </div>

    <Footer></Footer>
  </div>
</template>
<script>
import NavBar from "@/components/NavBar";
import NavBarHome from "@/components/NavBarHome";
import Footer from "@/components/Footer";
import {scrollMixin} from '@/mixins/scroll.js'
export default {
  mixins: [scrollMixin],
  components: {
    NavBar,
    NavBarHome,
    Footer,
  },
  mounted() {
    // 页面回退顶部
    window.scrollTo(0, 0);
  },
};
</script>
<style lang="scss" scoped>
.main_style {
  background-color: #ffffff;
  .content-width {
    width: 1200px;
    margin: 0px auto;
  }
  .commom-title {
    padding: 70px 0px 50px;
    font-size: 32px;
    font-family: "PingFangSC-Medium";
    color: rgba(0, 0, 0, 0.85);
    line-height: 45px;
    text-align: center;
  }
  .header {
    width: 100%;
    height: 540px;
    background: url("https://image.peerfintech.cn/peerfintech_website_v2/product/FunctionAdjustment/bg.png")
      center/cover no-repeat;
    .header-text {
      @extend .content-width;
      .header-title {
        font-size: 36px;
        font-family: "PingFangSC-Medium";
        color: #000000;
        line-height: 50px;
        padding-top: 160px;
      }
      .header-desc {
        width: 510px;
        color: rgba(0,0,0,0.75);
        font-size: 20px;
        line-height: 33px;
        margin-top: 36px;
      }
    }
  }
  .intro {
    padding-bottom: 70px;
    .intro-content {
      @extend .content-width;
      font-size: 18px;
      color: rgba(0, 0, 0, 0.65);
      line-height: 25px;
    }
  }
  .function {
    background: #f4f7fc;
    .content {
      @extend .content-width;
      padding-bottom: 20px;
      .line-title {
        display: flex;
        width: 100%;
        align-items: center;
        margin-bottom: 24px;
        div:nth-child(2) {
          padding: 0px 77px;
          font-size: 26px;
          color: #0075ff;
          line-height: 37px;
        }
        div:nth-child(1),
        div:nth-child(3) {
          flex: 1;
          height: 1px;
          background: #0075ff;
        }
      }
      .grid {
        padding-bottom: 26px;
        .grid-content {
          height: 352px;
          margin-bottom: 24px;
          background: #ffffff;
          display: flex;
          flex-direction: column;
          align-items: center;
          padding: 42px 24px 0px;
          .img {
            width: 124px;
            height: 124px;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .title {
            padding: 24px 0px;
            font-size: 22px;
            font-family: "PingFangSC-Medium";
            color: rgba(0, 0, 0, 0.85);
            line-height: 30px;
          }
          .text {
            font-size: 16px;
            color: rgba(0, 0, 0, 0.45);
            line-height: 22px;
            text-align: center;
          }
        }
      }
    }
  }
  .framework {
    padding-bottom: 70px;
    .framework-content {
      @extend .content-width;
      img {
        width: 100%;
      }
    }
  }
  .advantage {
    background: #f4f7fc;
    .advantage-content {
      @extend .content-width;
      padding-bottom: 70px;
      .el-row {
        margin-bottom: 24px;
        &:last-child {
          margin-bottom: 0;
        }
      }
      .grid-content {
        height: 370px;
        background: #ffffff;
        box-shadow: 3px 3px 15px 0px rgba(0, 0, 0, 0.1);
        padding: 40px 48px 0px 40px;
        .img {
          width: 124px;
          height: 124px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .title {
          padding: 24px 0px;
          font-size: 22px;
          font-family: "PingFangSC-Medium";
          color: rgba(0, 0, 0, 0.85);
          line-height: 30px;
        }
        .text {
          font-size: 16px;
          color: rgba(0, 0, 0, 0.45);
          line-height: 22px;
        }
      }
    }
  }
  .project {
    .project-content {
      @extend .content-width;
      padding-bottom: 70px;
      .grid-content {
        height: 194px;
        background: #f4f7fc;
        display: flex;
        flex-direction: column;
        align-items: center;
				padding:24px 48px 0px;
        .img {
          width: 66px;
          height: 66px;
          margin-bottom: 20px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .title {
          font-size: 22px;
          color: rgba(0, 0, 0, 0.85);
          line-height: 30px;
					text-align: center;
        }
      }
      .el-row {
        margin-bottom: 24px;
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
    
  }
}
</style>
